import cn from 'classnames';
import React, { CSSProperties, ElementType, RefObject } from 'react';
require("./Calendar.css");
var styles = {
  "Root": "Calendar-module-Root_Y6L"
};
import { SingleCalendar } from './Single/CalendarSingle';
import { DoubleCalendar } from './Double/CalendarDouble';
import { IDateFormat } from './helpers/validators';
export const Calendar = props => {
  const {
    calendarType = 'single',
    className,
    controlRef,
    innerRef,
    tag = 'div',
    style
  } = props;
  const Component = tag;
  return /*#__PURE__*/React.createElement(Component, {
    ref: innerRef || controlRef,
    className: cn(styles.Root, [className]),
    style: style
  }, calendarType === 'single' && SingleCalendar(props), calendarType === 'double' && DoubleCalendar(props));
};
if (process.env.NODE_ENV !== 'production') {
  Calendar.displayName = 'Calendar';
}